/**
 * Root-level shared constants and helpers.
 *
 * These are framework-free leaf values with no protocol / sim / content
 * dependencies, so BOTH the server-facing barrel (./index.ts) and the
 * presentation-safe client surface (./client.ts) can re-export them without the
 * client ever pulling in the server-authoritative barrel. Keep this module
 * dependency-free. See docs/architecture/system-overview.md (module rules) and
 * DECISIONS.md AD-122.
 */
export const GAME_NAME = 'The Great Cloud';
/**
 * The trade mark symbol shown after GAME_NAME where the name is the brand (title screens, the demo's end
 * card): UK trade mark application UK00004460475, published 2026-10-30. '™' while it is an application;
 * '®' only once the IPO register reads "Registered" (using ® before that is an offence, Trade Marks Act
 * 1994 s.95). The websites carry the same symbol as `&trade;`. In-world mentions of The Great Cloud (the
 * thing in the sky, in lore and dialogue) never carry it.
 */
export const TRADE_MARK = '™';
/** One line, shown where the game shows its fine print (the demo's end card). */
export const TRADE_MARK_NOTICE = `${GAME_NAME}${TRADE_MARK} is a trade mark of The Great Cloud LTD (UK trade mark application UK00004460475).`;
/**
 * Regional world instances (DECISIONS.md AD-012).
 * Player identity and the economy remain global (AD-011).
 */
export const SUPPORTED_REGIONS = ['eu', 'na', 'apac'];
export function isRegion(value) {
    return SUPPORTED_REGIONS.includes(value);
}
//# sourceMappingURL=meta.js.map